import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.frameLoadHandler = () => this.open()
    this.element.addEventListener("turbo:frame-load", this.frameLoadHandler)

    this.drawerCloseHandler = () => this.close()
    this.element.addEventListener("drawer:close", this.drawerCloseHandler)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.frameLoadHandler)
    this.element.removeEventListener("drawer:close", this.drawerCloseHandler)
  }

  open() {
    this.element.classList.remove("translate-x-full")
    this.element.classList.add("translate-x-0")
  }

  close() {
    this.element.classList.remove("translate-x-0")
    this.element.classList.add("translate-x-full")

    const frame = this.element.querySelector("turbo-frame")
    if (frame) {
      frame.removeAttribute("src")
      frame.innerHTML = ""
    }
  }
}
